<div class="col-12 lautrec-trainer-container px-0">
    <div class="row mx-0 ">
        <div class="col-4 col-md-4 align-items-center justify-content-end d-flex lautrec-trainer-container-image" >
            <img  src="assets/images/iconos/{{foto}}" class="entrenadora-img" alt="entrenadora" />
        </div>
        <div class="align-items-center col-8 col-md-8 d-flex lautrec-trainer-container-message">
            <p class="text-white" [innerHTML]="mensaje"></p>
        </div>
    </div>
</div>